import { Modal } from 'antd'
import { useAuth } from "../../contexts/AuthContext"

import { useStore } from "../../contexts/FireStoreContext"

const table = "users"

const useUsers = () => {
  const {
    // deleteAuthUser,
    passwordResetEmail
  } = useAuth()
  const {
    deleteDocument,
    updateDocumentField
  } = useStore()

  const approveUser = (id) => {
    updateDocumentField(table, "status", "a", id, "User Approved")
  }

  const blockUser = (id) => {
    updateDocumentField(table, "status", "b", id, "User Blocked")
  }

  const resetUserPassword = (row) => {
    passwordResetEmail(row.email)
  }

  const deleteConfirm = (row) => {
    // Modal.confirm({
    //   title: "Delete is temporarily disabled?",
    //   content: <>
    //     <div>This functionality is disabled</div>
    //   </>,
    //   centered: true,
    //   // onCancel: handleCancel,
    //   // onOk: () => { },
    //   okText: "Yes",
    //   cancelButtonProps: {
    //     danger: true,
    //     // style: { display: "none" }
    //   },
    //   cancelText: "No",
    //   okButtonProps: {
    //     danger: true
    //   }
    // })

    Modal.confirm({
      title: "Are you sure?",
      content: <>
        <div>You want to delete <b>User</b>?</div>
        <small>After delete, Data can't be recovered.</small>
      </>,
      centered: true,
      // onCancel: handleCancel,
      cancelText: "No",
      onOk: () => deleteDocument(table, row.id, "User"),
      // onOk: () => deleteAuthUser(row.id),
      okText: "Yes",
      cancelButtonProps: {
        danger: true
      },
      okButtonProps: {
        danger: true
      }
    })
  }

  return {
    approveUser,
    blockUser,
    deleteConfirm,
    resetUserPassword
  }
}

export default useUsers
